module.exports = __webpack_public_path__ + "static/media/excited1.38410a89.svg";